export default __webpack_public_path__ + "850e2f36ac94edb1a3bb56c5499acd77.png";